import { all } from 'redux-saga/effects';
import authSagas from './auth/saga';
import profileSaga from './profile/saga';

export default function* rootSaga(getState) {
  yield all([
    authSagas(),
    profileSaga(),
  ]);
}
